import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LANGS, detectLang } from "./diagnosticInauguralI18n";
import { SITE_ORIGIN } from "./seo";
import { DICT } from "./siteDict";

const KEY = "aetheris_lang";
const LangCtx = createContext({ lang: "fr", setLang: () => {}, t: DICT.fr });

const readInitial = (search) => {
  const q = new URLSearchParams(search).get("lang");
  if (LANGS.includes(q)) return q;
  try {
    const s = localStorage.getItem(KEY);
    if (LANGS.includes(s)) return s;
  } catch (_) { /* stockage indisponible */ }
  return detectLang();
};

export const LangProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [lang, setLangState] = useState(() => readInitial(location.search));

  useEffect(() => {
    const q = new URLSearchParams(location.search).get("lang");
    if (LANGS.includes(q) && q !== lang) setLangState(q);
  }, [location.search, lang]);

  useEffect(() => {
    document.documentElement.lang = lang;
    try { localStorage.setItem(KEY, lang); } catch (_) { /* stockage indisponible */ }
    applyHreflang(location.pathname);
  }, [lang, location.pathname]);

  const setLang = (l) => {
    if (!LANGS.includes(l)) return;
    setLangState(l);
    const params = new URLSearchParams(location.search);
    if (l === "fr") params.delete("lang"); else params.set("lang", l);
    const qs = params.toString();
    navigate({ pathname: location.pathname, search: qs ? `?${qs}` : "" }, { replace: true });
  };

  const value = useMemo(() => ({ lang, setLang, t: DICT[lang] || DICT.fr }), [lang]); // eslint-disable-line react-hooks/exhaustive-deps
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);

export function applyHreflang(pathname) {
  if (typeof document === "undefined") return;
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((n) => n.remove());
  const clean = (pathname || "/").replace(/\/+$/, "");
  const base = `${SITE_ORIGIN}${clean === "" ? "/" : clean}`;
  const add = (hreflang, href) => {
    const l = document.createElement("link");
    l.setAttribute("rel", "alternate"); l.setAttribute("hreflang", hreflang); l.setAttribute("href", href);
    document.head.appendChild(l);
  };
  add("fr", base);
  add("x-default", base);
  ["en", "es", "pt"].forEach((l) => add(l, `${base}?lang=${l}`));
}
